import AdminLayout from '@/layouts/AdminLayout.vue'
import PublicLayout from '@/layouts/PublicLayout.vue'

export default [
  {
    path: '/rental-files/create/:repairFileBoomerangId/products/:rentalProductId(\\d+)',
    name: 'rentalFileCreate',
    component: () =>
      import('@/views/restricted/rental-module/acquisition/RentalFileCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RENTAL_CREATE'],
      hideHeader: true,
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/rental-files/:rentalFileBoomerangId',
    name: 'rentalFileDetail',
    component: () =>
      import('@/views/restricted/rental-module/rental-file/RentalFileDetailView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RENTAL_READ'],
      hideHeader: true,
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/public/rental-files/add-product-picture',
    name: 'rentalFileAddPicture',
    component: () => import('@/views/public-access/rentalModule/RentalFileAddPictureView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  }
]
